<template>
  <div>
    <div v-if="gridV3Flag">
      <div v-if="model && model[prop] === true" class="rounded-pill" style="background-color: #CBF1D3">
        <font-awesome-icon :icon="column.fieldConfig.trueIcon" class="fa-xl px-3 text-success"
                           transform="shrink-2"></font-awesome-icon>
      </div>
      <div v-else class="rounded-pill" style="background-color: #FDE0D8">
        <font-awesome-icon :icon="column.fieldConfig.falseIcon" class="fa-xl px-3 text-danger" size="2xs"
                           transform="shrink-2"></font-awesome-icon>
      </div>
    </div>
    <div v-else>
      <font-awesome-icon v-if="model && model[prop] === true" :icon="column.fieldConfig.trueIcon"
                         class="fa-xl"></font-awesome-icon>
      <font-awesome-icon v-else :icon="column.fieldConfig.falseIcon" class="fa-xl"></font-awesome-icon>
    </div>
  </div>
</template>
<script>

import SessionManager from "@/utils/SessionManager";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";

export default {
  name: "CheckboxIconClass",
  mounted() {
  },

  methods: {},

  props: ["rowIndex", "prop", "model", "column"],

  data: () => ({
    gridV3Flag: SessionManager.hasFlag(FeatureFlag.GRID_V3)
  })

};
</script>
